export default {
    open: "立即回答",
    approve: "立即批准",
    impersonation: {
        title: "您代表 «{name}» 订购",
        cta: "切换回我自己",
    },
    "You have an unapproved orders": "您有订单需要批准",
    "You have orders to approve": "您有订单需要批准"
}